import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import '../Login.css';
import biswabangla from '../../../assets/images/biswabangla.png';

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post(
      "https://sutmmg.codydeasoftech.in/api/login",
      { username, password }
    );


    if (response.data.status === true) {
      const { user, token } = response.data.data;


       if (user.user_type_id === 2) {
        Swal.fire({
            title: "Login Failed",
            text: "Wrong User ID or Password.",
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: true,
            allowEscapeKey: true
        });

        return;
        }


      Swal.fire({
        title: "Login Successful",
        text: response.data.message,
        icon: "success",
        timer: 1500,
        showConfirmButton: false
      });

      // ✅ Correct storage
      localStorage.setItem("token", token);
      localStorage.setItem("userId", user.user_id);
      localStorage.setItem("userTypeId", user.user_type_id);
      localStorage.setItem("username", user.username);
      localStorage.setItem("name", user.name);

      // Example condition
      if (user.user_type_id === 3) {
        localStorage.setItem("vendor_id", user.user_id);
      }

      setTimeout(() => {
        navigate("/app/dashboard");
      }, 1200);
    } else {
      Swal.fire({
        title: "Login Failed",
        text: response.data.message,
        icon: "error"
      });
    }

  } catch (error) {
    console.error("LOGIN ERROR:", error?.response?.data);

    Swal.fire({
      title: "Error",
      text: error?.response?.data?.message || "Server error occurred.",
      icon: "error"
    });
  }
};


  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ textAlign:"center", marginBottom:"20px" }}>
          <img src={biswabangla} style={{ width:"100px", cursor: "pointer"  }} onClick={() => navigate("/landing")} />
          <h4 style={{ fontWeight:"bold" }}>
            {/* Urban School Uniform Stitching Project Management System */}

            Smart Urban Uniform Management System
            </h4>
          <p style={{ fontSize:"14px" }}>Sponsored by WB State Govt.</p>
          <p className="fw-bold" style={{ fontSize: "20px", color: "#3e7ff6" }}>SUDA LOGIN</p>

        </div>

        <div className="input-wrapper">
          <span className="icon"><i className="fas fa-envelope"></i></span>
          <input type="text" placeholder="Username" value={username} onChange={(e)=>setUsername(e.target.value)} required />
        </div>

        <div className="input-wrapper" style={{ position:'relative' }}>
          <span className="icon"><i className="fas fa-key"></i></span>
          <input type={showPassword ? "text" : "password"} placeholder="Password" value={password}
                 onChange={(e)=>setPassword(e.target.value)} required />
          <span className="toggle-password" onClick={()=>setShowPassword(!showPassword)}>
            <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
          </span>
        </div>

        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default Login;
